import RoutesMap from "route_control/RouteControl"
import { FineChargesList, FineChargesDetails, InvoiceList, PaymentList,DuesAndPayments, PaymentDetails, ExpenseBudget, BudgetTrackingList, ExpenseList, ExpenseDetails, Finance } from "pages/finance"

const FinanceRoute = () => {
    return [
        {
            path: RoutesMap.DUES_AND_PAYMENTS.path,
            element: <DuesAndPayments />,
        },
        {
            path: RoutesMap.FINE_CHARGES_LIST.path,
            element: <FineChargesList />,
        },
        {
            path: RoutesMap.FINE_CHARGES_DETAILS.path,
            element: <FineChargesDetails />,
        },
        {
            path: RoutesMap.INVOICE_LIST.path,
            element: <InvoiceList />,
        },
        {
            path: RoutesMap.PAYMENT_LIST.path,
            element: <PaymentList />,
        },
        {
            path: RoutesMap.PAYMENT_DETAILS.path,
            element: <PaymentDetails />,
        },
        {
            path: RoutesMap.EXPENSE_BUDGET.path,
            element: <ExpenseBudget />,
        },
        {
            path: RoutesMap.BUDGET_TRACKING_LIST.path,
            element: <BudgetTrackingList />,
        },
        {
            path: RoutesMap.EXPENSE_LIST.path,
            element: <ExpenseList />,
        },
        {
            path: RoutesMap.EXPENSE_DETAILS.path,
            element: <ExpenseDetails />,
        },
        {
            path: RoutesMap.FINANCE.path,
            element: <Finance />,
        },
    ]
}

export default FinanceRoute;